import resolveConfig from "tailwindcss/resolveConfig";
import tailwindConfig from "src/tailwind.config.js";
export default resolveConfig(tailwindConfig);
